import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router'

import { AlreadyCompletedPage } from './AlreadyCompletedPage'
import { BeneficialOwnersPage } from './BeneficialOwnersPage'
import { CompletePage } from './CompletePage'
import { ConfirmDetailsPage } from './ConfirmDetailsPage'
import { ControllingOwnerPage } from './ControllingOwnerPage'
import { OwnerInvitationFormLayout } from './Layout'
import { ManagedByThatchPage } from './ManagedByThatchPage'
import { OwnershipVerificationPage } from './OwnershipVerificationPage'
import { WelcomePage } from './WelcomePage'
import { NotFoundPage } from '../../apps/pages/NotFoundPage'

interface OwnerInvitationFormProps {
  employerId: string | null
  ownershipInvitationManagedByThatch?: boolean
  isEmployerOnboarding?: boolean
  router: typeof BrowserRouter
  routerProps?: Record<string, unknown>
}

export function OwnerInvitationForm ({
  employerId,
  ownershipInvitationManagedByThatch = false,
  isEmployerOnboarding = false,
  router: Router = BrowserRouter,
  routerProps,
}: OwnerInvitationFormProps) {
  return (
    <Router {...routerProps}>
      <Routes>
        <Route
          path='/employers/verification/owner_invitation'
          element={<OwnerInvitationFormLayout employerId={employerId} ownershipInvitationManagedByThatch={ownershipInvitationManagedByThatch} />}
        >
          <Route
            index
            element={
              ownershipInvitationManagedByThatch
                ? <ManagedByThatchPage />
                : <NavigatePreserveSearch to='welcome' replace />
            }
          />
          <Route path='managed-by-thatch' element={<ManagedByThatchPage />} />
          <Route
            path='welcome'
            element={<WelcomePage isEmployerOnboarding={isEmployerOnboarding} />}
          />
          <Route
            path='add-individual'
            element={<ControllingOwnerPage employerId={employerId} />}
          />
          <Route
            path='ownership-information'
            element={<OwnershipVerificationPage />}
          />
          <Route
            path='add-owners'
            element={<BeneficialOwnersPage />}
          />
          <Route
            path='confirm-details'
            element={<ConfirmDetailsPage />}
          />
          <Route
            path='complete'
            element={<CompletePage />}
          />
          <Route
            path='already-completed'
            element={<AlreadyCompletedPage />}
          />
          <Route
            path='*'
            element={<NotFoundPage />}
          />
        </Route>
      </Routes>
    </Router>
  )
}

function NavigatePreserveSearch ({ to, replace }: { to: string; replace?: boolean }) {
  const location = useLocation()
  return <Navigate to={{ pathname: to, search: location.search }} replace={replace} />
}
